import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    width: 100%;
    padding: 10px 20px;

    border-radius: 20px;
    border: 2px dashed ${SEMANTIC_COLORS.SECONDARY_BORDER};

    line-height: 23px;
  `,
};
